import { ref } from 'vue'

// Google accounts and properties
export const googleAccounts = ref([])
export const googleProperties = ref([])
export const isLoadingAccounts = ref(false)
export const isLoadingProperties = ref(false)
export const accountError = ref(null)
export const propertyError = ref(null)
export const selectedAccountId = ref(null)
export const selectedPropertyId = ref(null)
export const currentView = ref('accounts') // 'accounts' or 'properties'
export const isAddingNewAccount = ref(false)
export const isProcessingAccountSelection = ref(false)
export const isSavingProperty = ref(false)
